import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/Navbar.css';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const [isSubtitleShow, setIsSubtitleShow ] = useState(false);

    useEffect(() => {
        if (location.pathname === '/' || location.pathname === '/projekt' || location.pathname === '/magunkrol') {
            setIsSubtitleShow(true);
        } else {
            setIsSubtitleShow(false);
        }
    }, [location, navigate]);
    return (
        <>
        {/* <div className='col col-xl-8 offset-xl-1 offset-xxl-2'> */}
            <h1 className="main-title"
            onClick={
                    (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate('/');
                    }
            }
            >
                Egy hajóban...
            </h1>
            <h2 className={`subtitle ${isSubtitleShow ? 'show' : 'hide'}`}>
  történelmi regatta nemzeti örökségünk vizein
</h2>

        {/* </div> */}
            <div className="links-container">
                <div className='col col-xl-8 offset-xl-2 offset-xxl-2'>
                    <div className="links">
                        <Link to="/projekt"> <div>a projekt</div></Link>
                        <Link to="/hireink" className='hireink'>híreink - programjaink</Link>
                        <Link to="/magunkrol">magunkról</Link>

                    </div>
                </div>
        </div>
        </>
    );
};

export default Navbar;
